import Repository from './Repository';

class TranslatorServerRepository extends Repository {
	/**
	 * retrieve all translator servers
	 *
	 */
	all () {
		const include = [
			'oAuthClient',
			'translators'
		].join(',');

		return this.getWithToken(`/translator-servers?include=${include}`);
	}

	/**
	 * request the server to run the sync service for all translator servers
	 *
	 */
	syncAll () {
		return this.getWithToken('/translator-servers/sync-all');
	}

	deleteServer (id) {
		return this.deleteWithToken(`/translator-servers/${id}`);
	}
}

export default new TranslatorServerRepository();
